/**
 * @author: Angel Labrada Massó
 * @since v0.0.1
 * @date 8/5/22
 */
import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {Card, Row, Col, Input} from 'antd';
import { FontSizeOutlined } from '@ant-design/icons';
import {useTranslation} from 'react-i18next';
import styles from './index.less';

const PreviewTextType = ({parameter}) => {
  const {t} = useTranslation('templates');

  return (
    <Card className={styles.card}>
      <Row gutter={[16,16]} className="flex items-center justify-center">
        <Col span={6}>{parameter?.parameter?.name || parameter?.parameter?.label}</Col>
        <Col span={18}><Input size="large" placeholder={t('placeholderText')} style={{borderRadius: '5px'}} suffix={<FontSizeOutlined style={{color: '#C5C5C5'}}/>}/></Col>
      </Row>
    </Card>
  );
};

PreviewTextType.propTypes = {
  parameter: PropTypes.object
};

export default memo(PreviewTextType);
